"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
function XucPhoneEventListener($log, $rootScope, $q, XucLink, $window) {
    const _baseEventName = 'XucPhoneEventListener.';
    const _currentCallsEventName = 'CurrentCallsEvents';
    const _EVENT_DIALING = "EventDialing";
    const _EVENT_RINGING = "EventRinging";
    const _EVENT_ESTABLISHED = "EventEstablished";
    const _EVENT_RELEASED = "EventReleased";
    const _EVENT_ONHOLD = "EventOnHold";
    const _EVENT_FAILURE = "EventFailure";
    const _ANY = "Any";
    const _PHONE_DEVICE = "Phone";
    var handlerUnsubscription;
    var isUsingMobileApp = false;
    $rootScope.$on('isUsingMobileApp', (e, value) => {
        isUsingMobileApp = value;
    });
    var isUsingUaWebRtc = false;
    $rootScope.$on('isUsingUaWebRtc', (e, value) => {
        isUsingUaWebRtc = value;
    });
    var isUsingUaCti = false;
    $rootScope.$on('isUsingUaCti', (e, value) => {
        isUsingUaCti = value;
    });
    const shownForks = new Set();
    const _isFilteringForeignForks = () => isUsingMobileApp || isUsingUaWebRtc;
    const _belongsToLocalSession = (phoneEvent) => {
        var _a;
        const sipCallId = (_a = phoneEvent.userData) === null || _a === void 0 ? void 0 : _a.SIPCALLID;
        return sipCallId !== undefined && $window.xc_webrtc.doesSessionExists(sipCallId);
    };
    const _passesForeignForkFilter = (phoneEvent) => !_isFilteringForeignForks() || _belongsToLocalSession(phoneEvent);
    const _passesDeviceFilter = (phoneEvent) => !isUsingUaCti || phoneEvent.device === undefined || phoneEvent.device === _PHONE_DEVICE;
    const _shouldPropagate = (phoneEvent) => {
        if (!_passesDeviceFilter(phoneEvent)) {
            return false;
        }
        if (phoneEvent.eventType === _EVENT_FAILURE) {
            return true;
        }
        if (phoneEvent.eventType === _EVENT_RELEASED) {
            return !isUsingUaWebRtc || shownForks.has(phoneEvent.uniqueId);
        }
        return _passesForeignForkFilter(phoneEvent);
    };
    const _updateShownForks = (phoneEvent) => {
        if (phoneEvent.eventType === _EVENT_RELEASED) {
            shownForks.delete(phoneEvent.uniqueId);
        }
        else if (phoneEvent.eventType !== _EVENT_FAILURE) {
            shownForks.add(phoneEvent.uniqueId);
        }
    };
    var _onCtiPhoneEvent = function (phoneEvent) {
        if (!_shouldPropagate(phoneEvent)) {
            $log.debug("PhoneEvent is not propagated as it belongs to a call fork foreign to this application", phoneEvent);
            return;
        }
        _updateShownForks(phoneEvent);
        var eventWithType = _addCallType(phoneEvent);
        $rootScope.$emit(_baseEventName + _ANY, eventWithType);
        $rootScope.$emit(_baseEventName + phoneEvent.eventType, eventWithType);
    };
    var _addCallType = function (event) {
        var getType = (userData) => {
            if (!angular_1.default.isUndefined(userData) && !angular_1.default.isUndefined(userData.SIPCALLID)) {
                return $window.xc_webrtc.getMediaTypeBySipCallId(event.userData.SIPCALLID);
            }
            else {
                $log.debug('Unable to get SIP Call Id from event user data, fallback to audio media type', event);
                return $window.xc_webrtc.mediaType.AUDIO;
            }
        };
        var type = getType(event.userData);
        event.callType = (typeof type !== undefined && type !== null) ? type : $window.xc_webrtc.mediaType.AUDIO;
        return event;
    };
    var _onCtiCurrentCallsPhoneEvents = function (currentCallsPhoneEvents) {
        const propagatedEvents = currentCallsPhoneEvents.events.filter(angular_1.default.isObject).filter(_passesDeviceFilter).filter(_passesForeignForkFilter);
        propagatedEvents.forEach(_updateShownForks);
        $rootScope.$emit(_baseEventName + _currentCallsEventName, propagatedEvents);
    };
    const _onWebrtcTerminateEvent = function (event) {
        if (isUsingMobileApp &&
            event.type === $window.xc_webrtc.Incoming.TERMINATED &&
            $window.xc_webrtc.doesSessionExists(event.sipCallId)) {
            let releaseEvt = { eventType: "EventReleased", userData: { SIPCALLID: event.sipCallId } };
            $rootScope.$emit(_baseEventName + _ANY, releaseEvt);
            $rootScope.$emit(_baseEventName + _EVENT_RELEASED, releaseEvt);
        }
    };
    var _addHandler = function (scope, callback, targetEvent) {
        var unregister = _addHandlerCustom(callback, targetEvent);
        scope.$on('$destroy', unregister);
    };
    var _addHandlerCustom = function (callback, targetEvent) {
        if (typeof (targetEvent) === "undefined") {
            targetEvent = _ANY;
        }
        return $rootScope.$on(_baseEventName + targetEvent, function (event, phoneEvent) {
            $rootScope.$applyAsync(function () {
                callback(phoneEvent);
            });
        });
    };
    var _addDialingHandler = function (scope, callback) { _addHandler(scope, callback, _EVENT_DIALING); };
    var _addRingingHandler = function (scope, callback) { _addHandler(scope, callback, _EVENT_RINGING); };
    var _addEstablishedHandler = function (scope, callback) { _addHandler(scope, callback, _EVENT_ESTABLISHED); };
    var _addReleasedHandler = function (scope, callback) { _addHandler(scope, callback, _EVENT_RELEASED); };
    var _addOnHoldHandler = function (scope, callback) { _addHandler(scope, callback, _EVENT_ONHOLD); };
    var _addCurrentCallsPhoneEventsHandler = function (scope, callback) {
        _addHandler(scope, callback, _currentCallsEventName);
    };
    var _requestPhoneEventsForCurrentCalls = function () { var _a; (_a = $window.Cti) === null || _a === void 0 ? void 0 : _a.getCurrentCallsPhoneEvents(); };
    var _init = function () {
        var _a, _b;
        $log.info("Starting XucPhoneEventListener service");
        (_a = $window.Cti) === null || _a === void 0 ? void 0 : _a.setHandler($window.Cti.MessageType.PHONEEVENT, _onCtiPhoneEvent);
        (_b = $window.Cti) === null || _b === void 0 ? void 0 : _b.setHandler($window.Cti.MessageType.CURRENTCALLSPHONEEVENTS, _onCtiCurrentCallsPhoneEvents);
        handlerUnsubscription = $window.xc_webrtc.setHandler($window.xc_webrtc.MessageType.INCOMING, _onWebrtcTerminateEvent);
        XucLink.whenLoggedOut().then(_unInit);
    };
    var _unInit = function () {
        $log.info("Unloading XucPhoneEventListener service");
        isUsingMobileApp = false;
        isUsingUaWebRtc = false;
        isUsingUaCti = false;
        shownForks.clear();
        handlerUnsubscription();
        XucLink.whenLogged().then(_init);
    };
    XucLink.whenLogged().then(_init);
    return {
        EVENT_DIALING: _EVENT_DIALING,
        EVENT_RINGING: _EVENT_RINGING,
        EVENT_ESTABLISHED: _EVENT_ESTABLISHED,
        EVENT_RELEASED: _EVENT_RELEASED,
        EVENT_ONHOLD: _EVENT_ONHOLD,
        EVENT_FAILURE: _EVENT_FAILURE,
        addHandler: _addHandler,
        addHandlerCustom: _addHandlerCustom,
        addDialingHandler: _addDialingHandler,
        addRingingHandler: _addRingingHandler,
        addEstablishedHandler: _addEstablishedHandler,
        addReleasedHandler: _addReleasedHandler,
        addOnHoldHandler: _addOnHoldHandler,
        addCurrentCallsPhoneEventsHandler: _addCurrentCallsPhoneEventsHandler,
        requestPhoneEventsForCurrentCalls: _requestPhoneEventsForCurrentCalls
    };
}
exports.default = XucPhoneEventListener;
